<template>
  <div
    class="flex flex-wrap items-center justify-center transform"
    :class="{
      'rotate-90':vertical
    }"
  >
    <div
      v-for="(dot, index) in numberOfDots" :key="index"
      class=" -mt-8 cursor-pointer rounded-full bg-white transition-all duration-500 ease-in-out"
      @click="updateActiveDot(index)"
      :class="{
        'h-4 w-4':activeDots[index],
        'h-2 w-2':!activeDots[index],
        'ml-8':index!==0
      }"
    >
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelecterDots',
  props: {
    numberOfDots: {
      type: Number,
      default: 3
    },
    activeDot: {
      type: Number,
      default: 0
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    activeDots () {
      var toReturn = []
      for (var i = 0; i < this.numberOfDots; i++) {
        if (i === this.activeDot) toReturn.push(true)
        else toReturn.push(false)
      }
      return toReturn
    }
  },
  methods: {
    updateActiveDot (activeDotIndex) {
      this.$emit('onClick', activeDotIndex)
    }
  }
}
</script>
